import { Store as VuexStore, DispatchOptions, CommitOptions, Module } from "vuex";

import { RootState } from "@/store/root-state";
import type { Auth } from "@/models/auth";

import { state } from "./state";
import { actions, Actions } from "./actions";
import { getters, Getters } from "./getters";
import { mutations, Mutations } from "./mutations";

export { Auth };

export type AuthStore<S = Auth> = Omit<VuexStore<S>, "getters" | "commit" | "dispatch"> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  // TODO: How to configure a module without any actions?
  dispatch<K extends keyof Actions>(
    key: K,
    payload: Parameters<Actions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<Actions[K]>;
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>;
  };
};

export const store: Module<Auth, RootState> = {
  state,
  mutations,
  getters,
  // TODO: How to configure a module without any actions?
  actions,
  // TODO: With namespaced option turned on, having problem how to use dispatch with action types...
  // But without it, a bigger store might have clashes in namings
};
